import { Admin, fetchUtils,Resource, ListGuesser,EditGuesser, resolveBrowserLocale } from "react-admin";
//import { Admin, Resource } from "react-admin";
import polyglotI18nProvider from "ra-i18n-polyglot";
import { People, ViewListIcon } from "@mui/icons-material";
import italianCustom from '../Translations/italianCustom';

import merge from 'deepmerge';
import {MyMenu} from "./MyMenu";
import { ParentResource } from "./ParentResource";
import { ChildResource } from "./ChildResource";

import React, { useEffect, useState } from "react";
import { UserList,UserEdit, UserCreate } from "./users";
import { EnteAdminList,EnteAdminEdit, EnteAdminCreate } from "./entiAdmin";
import { GenitoreList,GenitoreEdit, GenitoreCreate } from "./genitori";
import { AccompagnatoreList,AccompagnatoreEdit, AccompagnatoreCreate } from "./accompagnatori";
import { Divider, ListSubheader } from "@mui/material";

import { TitoloList, TitoloEdit, TitoloCreate } from "./titoli";
import { Titolo_2List, Titolo_2Edit, Titolo_2Create } from "./titoli_2";
import { Titolo_3List, Titolo_3Edit, Titolo_3Create } from "./titoli_3";
import { Titolo_4List, Titolo_4Edit, Titolo_4Create } from "./titoli_4";
import { Titolo_5List, Titolo_5Edit, Titolo_5Create } from "./titoli_5";
import { Titolo_6List, Titolo_6Edit, Titolo_6Create } from "./titoli_6";
import { BambinoAdminList, BambinoAdminEdit, BambinoAdminCreate } from "./bambiniAdmin";
import {SlotList, SlotCreate, SlotEdit} from "./slots"
import { IscrizioneList, IscrizioneEdit, IscrizioneCreate } from "./iscrizioni";
import { Iscrizione_2List, Iscrizione_2Edit, Iscrizione_2Create } from "./iscrizioni_2";
import { Iscrizione_3List, Iscrizione_3Edit, Iscrizione_3Create } from "./iscrizioni_3";
import { Iscrizione_4List, Iscrizione_4Edit, Iscrizione_4Create } from "./iscrizioni_4";
import { Iscrizione_5List, Iscrizione_5Edit, Iscrizione_5Create } from "./iscrizioni_5";
import { Iscrizione_6List, Iscrizione_6Edit, Iscrizione_6Create } from "./iscrizioni_6";
import { PrenotazioneCreate, PrenotazioneEdit, PrenotazioneList } from "./prenotazioni";
import { Prenotazione_2Create, Prenotazione_2Edit, Prenotazione_2List } from "./prenotazioni_2";
import { Prenotazione_3Create, Prenotazione_3Edit, Prenotazione_3List } from "./prenotazioni_3";
import { Prenotazione_4Create, Prenotazione_4Edit, Prenotazione_4List } from "./prenotazioni_4";
import { Prenotazione_5Create, Prenotazione_5Edit, Prenotazione_5List } from "./prenotazioni_5";
import { Prenotazione_6Create, Prenotazione_6Edit, Prenotazione_6List } from "./prenotazioni_6";
import { Prenotazione_7Create, Prenotazione_7Edit, Prenotazione_7List } from "./prenotazioni_7";

import { Dashboard } from './dashboard';
import  {authProvider} from './authProvider';
import treeqlProvider from 'ra-data-treeql';
import LoginXKE from "./LoginXKE";
import {properties} from "../utils/properties";
import {setAdminStatusChangeCallback} from './authProvider';

export default function MyAdmin() {    
    const raLanguageItalian = require("../ra-italian/packages/ra-language-italian");
            
    const messages = {      
      it: merge(raLanguageItalian, italianCustom)
    };
    const i18nProvider = polyglotI18nProvider(
      (locale) => {
        const localeMessages = messages.it;
        console.log('i18nProvider: polyglotI18nProvider', {locale, localeMessages});
        return localeMessages;
      },
      resolveBrowserLocale()  
    );

    useEffect(() => {                                
        console.log("useEffect");
        console.log(localStorage);
        },[]);


    return ( 
      <div>  
          <Admin loginPage={LoginXKE} disableTelemetry dataProvider={treeqlProvider(properties.productionUrl+'/php/core/api/api.php/')} dashboard={Dashboard} authProvider={authProvider} i18nProvider={i18nProvider} menu={MyMenu}>      
          <Resource name="users" list={UserList}  edit={UserEdit} create={UserCreate} />
          <Resource name="enti" list={EnteAdminList}  edit={EnteAdminEdit} /> 
          <Resource name="slots" list={SlotList}  edit={SlotEdit} create={SlotCreate} /> 
          <Resource name="genitori" list={GenitoreList}  edit={GenitoreEdit} create={GenitoreCreate} /> 
          <Resource name="bambini" list={BambinoAdminList}  edit={BambinoAdminEdit} create={BambinoAdminCreate}/>  
          <Resource name="accompagnatori" list={AccompagnatoreList}  edit={AccompagnatoreEdit} create={AccompagnatoreCreate} /> 
          
            <Resource name="iscrizioni" list={IscrizioneList}  edit={IscrizioneEdit} create={IscrizioneCreate} options={{ label: "Iscrizioni" }} />                                                 
            <Resource name="prenotazioni" list={PrenotazioneList} create={PrenotazioneCreate} edit={PrenotazioneEdit} options={{ label: "Prenotazioni" }} />                                  
            <Resource name="titoli" list={TitoloList}  edit={TitoloEdit} create={TitoloCreate} options={{ label: "Titoli" }} />                                  
            <Resource name="iscrizioni_2" list={Iscrizione_2List}  edit={Iscrizione_2Edit} create={Iscrizione_2Create} options={{ label: "Iscrizioni" }} />                                                 
            <Resource name="prenotazioni_2" list={Prenotazione_2List} create={Prenotazione_2Create} edit={Prenotazione_2Edit} options={{ label: "Prenotazioni" }} />                                  
            <Resource name="titoli_2" list={Titolo_2List}  create={Titolo_2Create} options={{ label: "Titoli" }} />                        
            <Resource name="iscrizioni_3" list={Iscrizione_3List}  edit={Iscrizione_3Edit} create={Iscrizione_3Create} options={{ label: "Iscrizioni" }} />                                       
            <Resource name="prenotazioni_3" list={Prenotazione_3List} create={Prenotazione_3Create} edit={Prenotazione_3Edit} options={{ label: "Prenotazioni" }} />                        
            <Resource name="titoli_3" list={Titolo_3List}  create={Titolo_3Create} options={{ label: "Titoli" }} />                                            
            <Resource name="iscrizioni_4" list={Iscrizione_4List}  edit={Iscrizione_4Edit} create={Iscrizione_4Create} options={{ label: "Iscrizioni" }} />                                       
            <Resource name="prenotazioni_4" list={Prenotazione_4List} create={Prenotazione_4Create} edit={Prenotazione_4Edit} options={{ label: "Prenotazioni" }} />              
            <Resource name="titoli_4" list={Titolo_4List} create={Titolo_4Create} options={{ label: "Titoli" }} />                        
            <Resource name="iscrizioni_5" list={Iscrizione_5List}  edit={Iscrizione_5Edit} create={Iscrizione_5Create} options={{ label: "Iscrizioni" }} />                                       
            <Resource name="prenotazioni_5" list={Prenotazione_5List} create={Prenotazione_5Create} edit={Prenotazione_5Edit} options={{ label: "Prenotazioni" }} />                        
            <Resource name="titoli_5" list={Titolo_5List}  create={Titolo_5Create} options={{ label: "Titoli" }} />                        
            <Resource name="iscrizioni_6" list={Iscrizione_6List}  edit={Iscrizione_6Edit} create={Iscrizione_6Create} options={{ label: "Iscrizioni" }} />                                       
            <Resource name="prenotazioni_6" list={Prenotazione_6List} create={Prenotazione_6Create} edit={Prenotazione_6Edit} options={{ label: "Prenotazioni" }} />                                  
            <Resource name="titoli_6" list={Titolo_6List} create={Titolo_6Create} options={{ label: "Titoli" }} />              
            <Resource name="prenotazioni_7" list={Prenotazione_7List} create={Prenotazione_7Create} edit={Prenotazione_7Edit} options={{ label: "Prenotazioni" }} />                                  
          
          </Admin>
        {/** 
        <Admin loginPage={LoginXKE} disableTelemetry dataProvider={treeqlProvider(properties.productionUrl+'/php/core/api/api.php/')} dashboard={Dashboard} authProvider={authProvider} i18nProvider={i18nProvider}>      
          <Resource name="users" list={UserList}  edit={UserEdit} create={UserCreate}/>
          <Resource name="enti" list={EnteAdminList}  edit={EnteAdminEdit} create={EnteAdminCreate} /> 
          <Resource name="slots" list={SlotList}  edit={SlotEdit} create={SlotCreate} /> 
          <Resource name="genitori" list={GenitoreList}  edit={GenitoreEdit} create={GenitoreCreate} /> 
          <Resource name="bambini" list={BambinoAdminList}  edit={BambinoAdminEdit} create={BambinoAdminCreate}/> 
          <Resource name="iscrizioni" list={IscrizioneList}  edit={IscrizioneEdit} create={IscrizioneCreate} />        
          <Resource name="prenotazioni" list={PrenotazioneList} create={PrenotazioneCreate} edit={PrenotazioneEdit}  />
          <Resource name="titoli" list={TitoloList}  edit={TitoloEdit} create={TitoloCreate}/>       
        </Admin>
        */}
      </div>                 
    );      
  }  
